import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core'

@Component({
  selector: 'gb-unauthenticated-shell',
  templateUrl: './gb-unauthenticated-shell.component.html',
  styleUrls: ['./gb-unauthenticated-shell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  encapsulation: ViewEncapsulation.None,
})
export class GbUnauthenticatedShellComponent {
  @Input() showLogo = true
  @Input() showLiveChat = false
}
